import React, { Component } from 'react';
import AccessContainer from '../access/AccessContainer';
import { RootState } from '../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { AccessBase } from '../../domain/access/BaseAccess';
import RoleHelper from '../../RoleHelper';
import { changeAction } from '../../redux/actions/ActionActions';

class ActionAccessComponent extends Component<Props> {
  public render() {
    const {
      action: { action },
    } = this.props;
    const access: AccessBase = { permission: action.permission, collaborators: action.collaborators };
    return (
      <div className={'flex w-full h-full'}>
        <AccessContainer access={access} changeAccess={this.changeAccess} disabled={!RoleHelper.canManage('Action')} />
      </div>
    );
  }

  private changeAccess = (access: AccessBase) => {
    const {
      changeAction,
      action: { action },
    } = this.props;
    action.permission = access.permission;
    action.collaborators = access.collaborators;
    changeAction(action);
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  action: state.action,
});
const mapDispatchToProps = { changeAction };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(ActionAccessComponent);
